import { createPutEndpoint } from '@sonar-software/sonar-http';

export type PutSonarObjectStakeholdersBulkRequest = {
	sonarObjectIds: Array<number>;
	stakeholderIds: Array<number>;
};

export const putSonarObjectStakeholdersBulk = createPutEndpoint<PutSonarObjectStakeholdersBulkRequest>(
	'/api/v3/core/sonar-objects/stakeholders/bulk-add'
);
